<template>
  <div id="app">
    <spinner v-if="loading" :center="true" />
    <div v-else>
      <div v-if="!this.authenticated && openverification" class="main">
        <div class="header__div">
          <LogoLogo />
        </div>
        <transition name="fade" mode="out-in" id="resetpsw">
          <reset-password v-on:updated-password="handleReset" />
        </transition>
      </div>
      <div v-else-if="!this.authenticated" class="main">
        <div class="header__div">
          <LogoLogo />
        </div>
        <transition name="fade" mode="out-in" id="login">
          <login
            v-if="showLogin"
            v-on:update-view="toggleView"
            v-on:logged-in="toggleAuth"
          />
          <register
            v-else
            v-on:update-view="toggleView"
            v-on:logged-in="toggleAuth"
          />
        </transition>
      </div>
      <div v-else class="main">
        <div class="header__div d-flex up__in">
          <div
            class="col-4 point header__div__logo"
            @click="redirect"
            :style="{ 'background-image': `url(${topLogo})` }"
          >
            <span></span>

            <!-- <LogoLogo /> -->
          </div>

          <nav-bar
            v-on:logged-out="toggleAuth"
            :verificato_post="verificato"
            :has_anagrafica="user && user.anagrafica ? true : false"
            class="up__in__6"
          />
        </div>
        <b-toast
          variant="primary"
          id="nuovo-msg"
          title="Nuovo messaggio!"
          no-close-button
          class="text-center mx-auto"
          body-class="text-gray-dark"
        >
          <p class="text-justify mx-auto mb-0">
            Hai ricevuto un nuovo messaggio.
          </p>
        </b-toast>
        <b-toast
          variant="secondary"
          id="nuovo-consulto"
          title="Notifica consulto!"
          no-close-button
          class="text-center mx-auto"
          body-class="text-gray-dark"
        >
          <p class="text-justify mx-auto mb-0">{{ sockMsg }}.</p>
        </b-toast>
        <router-view
          class="router__main"
          v-on:has-verified="updateMenu"
          v-on:has-anagrafica="updateMenuAfterAnagrafica"
        />
        <div v-if="showChat">
          <call-us
            style="position: fixed; bottom: 8px; right: 8px; z-index: 99999;--call-us-form-header-background:#24b98c;--call-us-header-text-color:#ffffff;--call-us-form-height:470px;--call-us-form-width:250px;"
            phonesystem-url="https://3cx.qwince.com/"
            party="teleconsulto"
            allow-call="false"
            allow-video="false"
            authentication="both"
            invite-message="Salve, come possiamo aiutarti?"
            operator-name="Supporto Teleconsulto"
            allow-soundnotifications="true"
            enable-poweredby="false"
            ignore-queueownership="false"
            show-typing-indicator="true"
            auto-focus="true"
            enable-onmobile="true"
            popout="true"
            window-title="Contattaci"
            show-operator-actual-name="false"
            animation-style="none"
            minimized="true"
            minimized-style="bubble"
          ></call-us>
        </div>
      </div>

      <footer
        class="bg-dark-grey text-white row align-content-center px-0 mx-0"
      >
        <!-- <div class="row align-content-center"> -->
        <div class="col-12 py-0 px-2 text-center flex-wrap">
          <!-- <span class="font-weight-bold"> -->
          <a
            href="https://teleconsulto.online"
            target="_blank"
            class="text-secondary font-weight-bold mr-1"
            >©Teleconsulto</a
          >
          -
          <!-- </span> -->
          <!-- <span class="text-white">è un prodotto</span> -->
          <!-- è un prodotto -->
          <a
            href="https://teleconsulto.online/privacy"
            class="text-secondary font-weight-bold"
            target="_blank"
            >Privacy Policy</a
          >
          -
          <a
            href="https://teleconsulto.online/tec/"
            class="text-secondary font-weight-bold"
            target="_blank"
            >Termini e Condizioni</a
          >
        </div>
        <div class="col-12 py-0 px-2 text-center">
          <p class="mb-0">
            <a
              href="https://qwince.com/it/"
              target="_blank"
              class="text-white font-weight-bold ml-1"
              >© Copyright Qwince – Securproject.it S.r.l.</a
            >
            – Via Catania, 5 – 90141 Palermo (Italy) – P.IVA 05585930828 REA PA
            – 264064‏ – Tel: +39 091 6167766
          </p>
        </div>
      </footer>
    </div>
  </div>
</template>
<script>
import Login from "@/components/Login.vue";
import ResetPassword from "@/components/ResetPassword.vue";
import Register from "@/components/Register.vue";
import Spinner from "@/components/Spinner.vue";
import NavBar from "@/components/menu/NavBar.vue";
import LogoLogo from "../public/svg/logoSanita.svg";
// import DfLogo from "../public/svg/logo_df_c.svg";
import firebase from "firebase";
import * as io from "socket.io-client";
export default {
  name: "App",
  components: {
    Login,
    Register,
    Spinner,
    NavBar,
    LogoLogo,
    ResetPassword,
  },
  data() {
    return {
      authenticated: false,
      showLogin: true,
      loading: true,
      verificato: null,
      socket: io(process.env.VUE_APP_SOCKET_CONNECTION),
      openverification: this.$route.query.openverification,
      showChat: false,
      user: null,
      sockMsg: null,
    };
  },
  watch: {
    authenticated: function(newVal, oldVal) {
      // console.log("newVal", newVal);
      // console.log("oldVal", oldVal);
      if (newVal !== oldVal && newVal === true) {
        // console.log("in if", newVal);
        !this.showChat && this.loadChatScript();
      }
    },
  },
  computed: {
    topLogo: function() {
      if (this.user && this.user.dottorfarma) {
        return "/img/logo_df.png";
      }
      return "/img/logo.png";
    },
  },
  sockets: {
    message(msg) {
      this.$bvToast.show("nuovo-msg");
    },
    consulto(msg) {
      console.log("nuovo consulto", msg);
      this.$bvToast.show("nuovo-consulto");
      let parseMsg = JSON.parse(msg)
      this.sockMsg = parseMsg.consulto;
    },
  },
  methods: {
    authCheck() {
      this.$axios
        .get("/authcheck")
        .then((res) => {
          this.authenticated = res.data.data;
          this.loading = false;
          !this.authenticated && this.redirect();
          this.authenticated && this.getUser();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    dottorfarmaAuth() {
      this.loading = true;
      var url =
        "api/" +
        process.env.VUE_APP_VERSION +
        "authenticate/dottorfarmauser?token=" +
        this.$route.query.token;
      this.$axios
        .get(url)
        .then((res) => {
          this.authCheck();
          this.loading = true;
          this.$router.push({ name: "Home" });
          // this.$router.push("/");
        })
        .catch((err) => {
          this.msg = err;
          if (err.response && err.response.status === 401) {
            this.$router.go();
          }
        });
    },
    getUser() {
      var url = process.env.VUE_APP_VERSION + "users/user";
      this.$axios
        .get(url)
        .then((res) => {
          this.user = res.data.data;
          this.$socket.client.emit("register", res.data.data.hashid);
          this.askForNotification();
          this.loadChatScript();
          // if (res.data.data.consenso_notifiche == false) {
          //   this.askForNotification();
          // } else {
          //   this.checkIfRegistered();
          // }
        })
        .catch((err) => {
          // console.log("error", err);
          this.msg = err;
          if (err.response && err.response.status === 401) {
            this.$router.go();
          }
        });
    },
    askForNotification() {
      const messaging = firebase.messaging();
      var self = this;
      messaging
        .requestPermission()
        .then(function() {
          console.log("Notification permission granted.");
          // var self = this;
          messaging.getToken().then((current) => {
            var url = process.env.VUE_APP_VERSION + "users/token";
            var data = { token: current };
            self.$axios
              .put(url, data)
              .then(() => {
                // console.log(res.data.data);
                // if (res.data.data.consenso_notifiche == false) {
                //   this.askForNotification();
                // } else {
                //   this.checkIfRegistered();
                // }
              })
              .catch((err) => {
                // this.msg = err;
                if (err.response && err.response.status === 401) {
                  this.$router.go();
                }
              });
          });
          messaging.onMessage(function(payload) {
            // console.log("Message received. ", payload);
            this.$bvToast.show("nuovo-msg");
          });
        })
        .catch(function(err) {
          console.log("Unable to get permission to notify.", err);
        });
    },
    toggleView() {
      this.showLogin = !this.showLogin;
    },
    toggleAuth() {
      this.authenticated = !this.authenticated;
    },
    redirect() {
      if (this.$route.name !== "Home") this.$router.push("/");
    },
    updateMenu() {
      this.verificato = true;
    },
    updateMenuAfterAnagrafica() {
      this.getUser();
    },
    handleReset() {
      if (this.$route.name !== "Home") {
        this.$router.push("/");
      }
      this.$router.go();
    },
    loadChatScript() {
      // console.log("****************************loading script");
      let chatScript = document.createElement("script");
      chatScript.setAttribute("src", "https://3cx.qwince.com/callus.js");
      chatScript.setAttribute("charset", "utf-8");
      document.head.appendChild(chatScript);
      this.showChat = true;
    },
  },
  created() {
    // !this.$store.state.isAuth && this.authCheck();
    if (this.$route.query.token) {
      this.dottorfarmaAuth();
    } else {
      this.authCheck();
    }
  },
  mounted() {
    // console.log("***************************mounted", this.$socket);
    this.authenticated && this.loadChatScript();
  },
};
</script>
<style lang="scss">

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.up__in {
  z-index: 5;
}
.up__in__6 {
  z-index: 6;
}
.banner__video {
  max-width: 100vw;
}
</style>
